// extracted by mini-css-extract-plugin
export default {"all":"tres_all__4kx6F","fila":"tres_fila__Q5n2e","card":"tres_card__0VTsQ","cardCont":"tres_cardCont__gVI8m"};